import { create } from "zustand";

type EntityType = "accounts" | "users";

type DrawerEntity = {
  id: string;
  type: EntityType;
  signalId?: string;
};

type EntityDrawerStore = {
  isOpen: boolean;
  entity: DrawerEntity | null;
  openDrawer: (entity: DrawerEntity) => void;
  closeDrawer: () => void;
};

const useEntityDrawerStore = create<EntityDrawerStore>((set) => ({
  isOpen: false,
  entity: null,
  openDrawer: (entity: DrawerEntity) => set({ isOpen: true, entity }),
  closeDrawer: () => set({ isOpen: false, entity: null }),
}));

export default useEntityDrawerStore;
